type homeProps = {
  title: string;
};

const HomePage = ({ title }: homeProps) => {
  return (
    <div className="home-title">
      <h1 className="page-title pb-3">{title}</h1>
    </div>
  );
};

export default HomePage;
